export enum HttpCodes {
  Succeeded = 200,
  Forbidden = 403,
  NotFound = 404,
  ServerError = 500,
}

export default HttpCodes;
